import { VideoSource } from "@/store";
import React, { useRef, useEffect } from "react";

// Define a single shared observer
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const videoElement = entry.target as HTMLVideoElement;
      if (videoElement) {
        if (entry.isIntersecting) {
          // Do something if the video is visible
        } else {
          videoElement.pause();
        }
      }
    });
  },
  { threshold: 0.5 }
);

export type CoverVideoProps = {
  url: string;
  sources: VideoSource[];
  autoPlay: boolean;
  alt: string;
};

export const CoverVideo = ({
  url,
  sources,
  autoPlay,
  alt,
}: CoverVideoProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (videoElement) {
      // Add the video element to the observer and map
      observer.observe(videoElement);
    }

    return () => {
      if (videoElement) {
        // Clean up when the component unmounts
        observer.unobserve(videoElement);
      }
    };
  }, [autoPlay]);

  return (
    <video
      ref={videoRef}
      className="top-0 block h-full w-full object-contain object-center"
      aria-label={alt}
      autoPlay={autoPlay}
      poster={url}
      muted
      controls
      controlsList="nodownload"
      playsInline
      preload="metadata"
    >
      {sources.map((src) => (
        <source
          key={src.videoUrl}
          src={src.videoUrl}
          type={src.mimeType}
          height={src.height}
          width={src.width}
        />
      ))}
    </video>
  );
};
